import styled from "@emotion/styled";

import { theme } from "../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const BackIconRoot = styled.span({
    display: "inline-block",
    position: "relative",
    width: 20,
    height: 20,
    marginBottom: -4,
});

export const BackIconBody = styled.span(props => ({
    top: 3,
    left: 6,
    display: "inline-block",
    position: "absolute",
    border: `2px solid ${theme(props).icons.color}`,
    borderRight: "none",
    borderTop: "none",
    width: 11,
    height: 11,
    transform: "rotate(45deg)",
}));

export const RoundedButton = styled.button(props => ({
    cursor: "pointer",
    border: `1px solid ${theme(props).icons.color}`,
    outline: 0,
    width: 37,
    height: 37,
    borderRadius: 18,
    display: "inline-block",
    backgroundColor: "transparent",
    textAlign: "center",
    padding: "9 0 0 0",
    boxSizing: "border-box",

    ":hover": {
        borderColor: theme(props).icons.hoverColor,
        [`${BackIconBody}`]: {
            borderColor: theme(props).icons.hoverColor,
        },
    },
}));
